import { __assign } from '../../../../../../../../../node_modules/tslib/tslib.es6.js';
import { ExpandMore } from '@mui/icons-material';
import { useTheme, Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ZigButton from '../../../../../inputs/ZigButton/index.js';
import React__default, { lazy, useState, useMemo, Suspense } from 'react';
import Filter from '../../../filters/Filter/index.js';
import { useTranslation } from 'react-i18next';

var SwipeableDrawer = lazy(function () { return import('@mui/material/SwipeableDrawer'); });
var MobileFilterDrawer = function (_a) {
    var filtersProp = _a.filters, open = _a.open, onClose = _a.onClose, onChange = _a.onChange, resetFilters = _a.resetFilters, prefixId = _a.prefixId;
    var isMulti = Array.isArray(filtersProp);
    var filters = isMulti ? filtersProp : [filtersProp];
    var t = useTranslation("zignaly-ui", { keyPrefix: "ZigFilters" }).t;
    var _b = useState(filters.length === 1 ? filters[0].id : false), expanded = _b[0], setExpanded = _b[1];
    var theme = useTheme();
    var styles = useMemo(function () { return ({
        accordion: {
            border: "none",
            borderTop: "1px dotted ".concat(theme.palette.neutral600),
            margin: "10px 0 10px !important",
            boxShadow: "none",
            "&:before": {
                height: 0,
            },
        },
        accordionSummary: {
            minHeight: "0 !important",
            ".Mui-expanded": { margin: "12px 0 !important" },
        },
        accordionDetails: { padding: "2px 24px" },
    }); }, [theme]);
    return (React__default.createElement(Suspense, null,
        React__default.createElement(SwipeableDrawer, { anchor: "bottom", open: open, onOpen: function () { }, disableSwipeToOpen: true, onClose: onClose },
            React__default.createElement(Box, { p: 2 },
                React__default.createElement(Box, { display: "flex", alignItems: "center", mt: "3px", mb: "19px" },
                    React__default.createElement(Box, { flex: 1 }),
                    React__default.createElement(Box, { flex: 1, justifyContent: "center", display: "flex" },
                        React__default.createElement(Typography, { variant: "h3" }, isMulti ? "Filters" : filters[0].label)),
                    React__default.createElement(Box, { flex: 1, justifyContent: "flex-end", display: "flex" },
                        React__default.createElement(ZigButton, { variant: "text", onClick: resetFilters, id: "".concat(prefixId, "__dropdown-reset") }, t("reset", { defaultValue: "Reset" })))),
                filters.map(function (filter) { return (React__default.createElement(Accordion, { key: filter.id, sx: styles.accordion, expanded: expanded === filter.id, onChange: function (_, isExpanded) {
                        return setExpanded(isExpanded || filters.length === 1 ? filter.id : false);
                    } },
                    React__default.createElement(AccordionSummary, { expandIcon: filters.length > 1 ? React__default.createElement(ExpandMore, { sx: { color: "neutral200" } }) : null, id: "".concat(prefixId, "__accordion-filter-header-").concat(filter.id), sx: styles.accordionSummary }, isMulti ? filter.label : ""),
                    React__default.createElement(AccordionDetails, { sx: styles.accordionDetails },
                        React__default.createElement(Filter, { filter: __assign(__assign({}, filter), { label: "" }), mobile: true, onChange: onChange })))); })),
            React__default.createElement(ZigButton, { onClick: onClose, sx: { alignSelf: "center", m: "8px 0 24px" }, id: "".concat(prefixId, "__multi-dropdown-show") }, t("show-results", { defaultValue: "Show Results" })))));
};

export { MobileFilterDrawer as default };
